var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { config as fontAwesomeConfig } from '@fortawesome/fontawesome-svg-core';
export var Currency;
(function (Currency) {
    Currency["Euro"] = "euro";
})(Currency || (Currency = {}));
;
fontAwesomeConfig.autoAddCss = false;
window.lotus = __assign({}, window.lotus);
var config = __assign({ internal_date_format: 'YYYY-MM-DD', input_date_format: 'DD-MM-YYYY', display_date_format: 'ddd D MMM YYYY', internal_date_time_format: 'YYYY-MM-DD HH:mm:ss', input_date_time_format: 'DD-MM-YYYY HH:mm:ss', display_date_time_format: 'ddd D MMM YYYY, HH:mm:ss', currency: Currency.Euro, thousands_separator: '.', decimal_separator: ',', locale: 'en', timezone: 'Europe/Amsterdam' }, window.lotus.config);
export default config;
